export const LoginSteps = Object.freeze({
  /** 多個入口頁面，用在登入或不登入，目前只有 FunBook 多這一頁 */
  Landing: 'landing',
  /** 登入 / 註冊 入口頁面 */
  Index: 'index',
  SignUp: 'sign-up',
  Login: 'login',
  ForgotPassword: 'forgot-password',
})

/** 從哪裡觸發開啟登入視窗 */
export const LoginDialogTrigger = Object.freeze({
  Header: 0,
  BookingFlow: 1,
  OrderDetail: 2,
})

export const oauthStateSeeds = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'p',
  'Q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '_',
  '[',
  ']',
  '{',
  '}',
]

export enum MemberAuthType {
  MemberAuthTypeEmail,
  MemberAuthTypeGoogle,
  MemberAuthTypeFB,
  MemberAuthTypeGuest,
  MemberAuthTypeLINE,
  MemberAuthTypeCathay,
  MemberAuthTypeApple,
  MemberAuthTypeTNG,
  MemberAuthTypeRwG,
  MemberAuthTypePartner,
  MemberAuthTypeAnonymous,
}
